import { useAdminSelector } from "../../../stores/AdminStore";
import { useMemo } from "react";
import { useBrands } from "./useBrands";
import { Brand } from "@unleashed/models/Brand";
import { Park } from "@unleashed/models/Park";

export const useAuthorizedBrands = (brandSlug?: string) => {
  const brands = useBrands(brandSlug);
  const brandPermissions = useAdminSelector(s => s.auth.permissions);

  return useMemo(() => {
    const authorizedBrands: Brand[] = [];
    brands.forEach(b => {
      const authorizedLocations: Park[] = [];
      const brand = brandPermissions
        ?.find(p => p.urlSlug === "all-brands" || p.urlSlug === b.urlSlug);

      if (!brand) {
        return;
      }

      b.locations?.forEach(l => {
        const location = brand.locations?.find(p => p.urlSlug === "all-locations" || p.urlSlug === l.urlSlug);
        if (!location) {
          return;
        }

        authorizedLocations.push({
          ...l,
          permissions: location.permissions
        });
      });

      authorizedBrands.push({
        ...b,
        locations: authorizedLocations
      });
    });

    return authorizedBrands;
  }, [brandPermissions, brands]);
};
